module.exports = __webpack_public_path__ + "static/media/14.6c1aba66.jpg";